type InventoryItemStatus = 'claimable' | 'claimed' | 'applied' | 'used' | 'expired' | 'cancelled'
type ActivationType = 'auto' | 'manual'
type BoostUnit = 'percentage' | 'fixed'
interface BaseInventoryItem {
  id: string
  playerId: string
  status: InventoryItemStatus
  createdAt: string
  expiresAt?: string | null
  claimedAt?: string | null
  applicableGames: string[]
  quantity?: number
  tags: string[]
  originType: string
  originId: string
}
export interface Booster extends BaseInventoryItem {
  type: 'booster'
  boost: {
    value: number
    unit: BoostUnit
  }
  activationType: ActivationType
}

export interface Bonus extends BaseInventoryItem {
  type: 'bonus'
  amount: number
  currency: string
}

export type InventoryItem = Booster | Bonus

export interface InventoryResponse {
  playerId: string
  items: InventoryItem[]
}

export const isBooster = (item: InventoryItem): item is Booster => {
  return item.type === 'booster'
}

export const isBonus = (item: InventoryItem): item is Bonus => {
  return item.type === 'bonus'
}

export const isClaimed = (item: InventoryItem): boolean => {
  return item.status === 'claimed'
}

// Helper to get active boosters that can be auto-applied
const getAutoApplyBoosters = (items: InventoryItem[]): Booster[] => {
  return items.filter((item): item is Booster => isBooster(item) && item.activationType === 'auto')
}

// Get the oldest auto-apply booster
export const getOldestAutoApplyBooster = (items: InventoryItem[]): Booster | null => {
  const autoBoosters = getAutoApplyBoosters(items)
  if (autoBoosters.length === 0) return null

  return autoBoosters.reduce((oldest, current) => {
    return new Date(current.createdAt) < new Date(oldest.createdAt) ? current : oldest
  })
}